var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3798 8.00025L15.7659 2.61417C16.0774 2.30266 16.0774 1.79715 15.7659 1.48515L14.5144 0.233629C14.2028 -0.0778762 13.6973 -0.0778762 13.3853 0.233629L7.99975 5.62021L2.61367 0.234129C2.30216 -0.0773761 1.79665 -0.0773761 1.48465 0.234129L0.233629 1.48515C-0.0778762 1.79665 -0.0778762 2.30216 0.233629 2.61417L5.61971 8.00025L0.233629 13.3863C-0.0778762 13.6978 -0.0778762 14.2033 0.233629 14.5154L1.48515 15.7669C1.79665 16.0784 2.30216 16.0784 2.61417 15.7669L7.99975 10.3803L13.3858 15.7664C13.6973 16.0779 14.2028 16.0779 14.5149 15.7664L15.7664 14.5149C16.0779 14.2033 16.0779 13.6978 15.7664 13.3858L10.3798 8.00025Z",
    fill: "#01035E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.8de7d6cf.svg";
export { ForwardRef as ReactComponent };